var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.519 0a2.593 2.593 0 0 0-2.593 2.593v3.361a2.615 2.615 0 0 0-.37-.026H2.592A2.593 2.593 0 0 0 0 8.52v8.89a2.593 2.593 0 0 0 2.593 2.592h8.888a2.593 2.593 0 0 0 2.593-2.593v-2.963c0-.126-.01-.25-.027-.372h3.36A2.593 2.593 0 0 0 20 11.48V2.593A2.593 2.593 0 0 0 17.407 0H8.52Zm-.37 2.593a.37.37 0 0 1 .37-.37h8.888a.37.37 0 0 1 .37.37v8.888a.37.37 0 0 1-.37.37H8.52a.37.37 0 0 1-.37-.37V2.593ZM2.221 8.52a.37.37 0 0 1 .37-.37h2.963a.37.37 0 0 1 .37.37v2.963a2.593 2.593 0 0 0 2.593 2.593h2.963a.37.37 0 0 1 .37.37v2.963a.37.37 0 0 1-.37.37H2.593a.37.37 0 0 1-.37-.37V8.52Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-copy.6ba3b46c16ecaf3b24badc46d6d2ffa6.svg";